const search = document.querySelector('.home-hero__search');

if (search) {
    const i18n = JSON.parse(search.dataset.i18n || '{}');
    const trigger = search.querySelector('.home-hero__search-trigger');
    const summary = search.querySelector('[data-guests-summary]');
    const rows = [...search.querySelectorAll('[data-guests-row]')];

    function formatSummary() {
        const adults   = Number(document.getElementById('selectedAdultCount')?.value || 0);
        const children = Number(document.getElementById('selectedChildCount')?.value || 0);
        const infants  = Number(document.getElementById('selectedInfantCount')?.value || 0);
        const total    = adults + children + infants;

        if (total > 0) {
            const template = total > 1 ? i18n.guestsOther : i18n.guestsOne;
            summary.textContent = template?.replace('%d', total) ?? `${total}`;
        } else {
            summary.textContent = i18n.guestsDefault ?? '';
        }
    }

    function getOptionValues(select) {
        return [...select.options].map(opt => Number(opt.value)).filter(v => !Number.isNaN(v));
    }

    rows.forEach(row => {
        const select  = document.getElementById(row.dataset.guestsRow);
        const display = row.querySelector('[data-guests-display]');
        const min     = Number(row.dataset.guestsMin || 0);

        if (!select || !display) return;

        function syncDisplay() {
            display.textContent = select.value || String(min);
            formatSummary();
        }

        // Le widget tiers (base.js) remplit les <select> de façon asynchrone après son chargement
        new MutationObserver(syncDisplay).observe(select, { childList: true });
        select.addEventListener('change', syncDisplay);
        syncDisplay(); // synchronise tout de suite si base.js a déjà rempli le select avant cette ligne

        row.querySelectorAll('[data-guests-action]').forEach(btn => {
            btn.addEventListener('click', () => {
                const values = getOptionValues(select);
                if (!values.length) return;

                const current   = Number(select.value || min);
                const direction = btn.dataset.guestsAction === 'increment' ? 1 : -1;
                const next      = current + direction;

                if (!values.includes(next)) return;

                select.value = String(next);
                select.dispatchEvent(new Event('change'));
            });
        });
    });

    const submitBtn = search.querySelector('.home-hero__search-submit');
    const baseBookingUrl = search.dataset.bookingBaseUrl;

    // base.js (ancien moteur AVP) ne remplit AVP_arrivalDate/AVP_nights que dans sa
    // fonction validate(), appelée au clic — qu'on a retirée pour ne plus soumettre
    // l'ancien formulaire. On recalcule donc nous-mêmes ces valeurs, même logique
    // que validate() côté base.js, sans le form.submit() final.
    function computeArrivalAndNights() {
        const lm = document.getElementById('AVP_list_months');
        const ld = document.getElementById('AVP_list_days');
        const ldm = document.getElementById('AVP_list_dmonths');
        const ldd = document.getElementById('AVP_list_ddays');

        if (!lm || !ld) return { arrivalDate: '', nights: '' };

        const arrivalYm = lm.options[lm.selectedIndex].value; // "YYYY-M"
        const arrivalDay = ld.options[ld.selectedIndex].value;
        const arrivalDate = `${arrivalYm}-${arrivalDay}`;

        let nights = 1;
        if (ldm && ldd) {
            const [ay, am] = arrivalYm.split('-').map(Number);
            const arrival = new Date(ay, am - 1, Number(arrivalDay));
            const departureYm = ldm.options[ldm.selectedIndex].value;
            const departureDay = ldd.options[ldd.selectedIndex].value;
            const [dy, dm] = departureYm.split('-').map(Number);
            const departure = new Date(dy, dm - 1, Number(departureDay));
            const msPerDay = 1000 * 60 * 60 * 24;
            nights = Math.round((departure.setHours(0, 0, 0, 0) - arrival.setHours(0, 0, 0, 0)) / msPerDay);
        }

        return { arrivalDate, nights };
    }

    // Maj le href juste avant le clic (mousedown survient avant click) pour que le script
    // D-Edge lise les bonnes valeurs, peu importe l'ordre de chargement entre les deux scripts.
    submitBtn?.addEventListener('mousedown', () => {
        const { arrivalDate, nights } = computeArrivalAndNights();

        const params = new URLSearchParams({
            arrivalDate,
            nights: String(nights),
            selectedAdultCount: document.getElementById('selectedAdultCount')?.value || '1',
            selectedChildCount: document.getElementById('selectedChildCount')?.value || '0',
            selectedInfantCount: document.getElementById('selectedInfantCount')?.value || '0',
        });

        submitBtn.setAttribute('href', `${baseBookingUrl}&${params.toString()}`);
    });

    trigger?.addEventListener('click', () => {
        const isOpen = search.classList.toggle('is-guests-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    document.addEventListener('click', e => {
        if (!search.contains(e.target)) {
            search.classList.remove('is-guests-open');
            trigger?.setAttribute('aria-expanded', 'false');
        }
    });

    formatSummary();
}
